import { destination, point, type Units } from "@turf/turf";
import type { Coordinate } from "./coordinate";

const meters: { units: Units } = { units: 'meters' };

export enum Anchor {
  Center = 'Center',

  BottomCenter = 'Bottom Center',
  BottomLeft = 'Bottom Left',
  BottomRight = 'Bottom Right',

  TopCenter = 'Top Center',
  TopLeft = 'Top Left',
  TopRight = 'Top Right'
}

interface GetAnchorCoordinate {
  anchor: Anchor;
  coordinate: Coordinate;
  heading: number;
  width: number;
  length: number;
}

export function createAnchor(options: GetAnchorCoordinate) {

  const {
    coordinate,
    anchor,
    width,
    length,
    heading
  } = options;

  let startPosition = point([coordinate.longitude, coordinate.latitude]);

  switch (anchor) {
    case Anchor.Center: {
      startPosition = destination(
        startPosition,
        width / 2,
        -90 + heading,
        meters,
      );
      startPosition = destination(
        startPosition,
        length / 2,
        -180 + heading,
        meters,
      );
      break;
    }
    case Anchor.BottomCenter: {
      startPosition = destination(
        startPosition,
        width / 2,
        -90 + heading,
        meters,
      );
      break;
    }
    case Anchor.BottomLeft: {
      break;
    }
    case Anchor.BottomRight: {
      startPosition = destination(
        startPosition,
        width,
        -90 + heading,
        meters,
      );
      break;
    }
    case Anchor.TopCenter: {
      startPosition = destination(
        startPosition,
        width / 2,
        -90 + heading,
        meters,
      );
      startPosition = destination(
        startPosition,
        length,
        -180 + heading,
        meters,
      );
      break;
    }
    case Anchor.TopLeft: {
      startPosition = destination(
        startPosition,
        length,
        -180 + heading,
        meters,
      );
      break;
    }
    case Anchor.TopRight: {
      startPosition = destination(
        startPosition,
        width,
        -90 + heading,
        meters,
      );
      startPosition = destination(
        startPosition,
        length,
        -180 + heading,
        meters,
      );
      break;
    }
    default:
      break;
  }
  return startPosition;
}
